const isOnePlatformEnabled =
  import.meta.env.VITE_CLASSIC_TWENTYTHREE_ENABLED === 'false'

export default isOnePlatformEnabled
